import { API_CALL } from '../../../../middleware/api';
import { actions as orgFilterActions } from '../../../../components/OrgSelect/orgFilterActions';

// Redux actions for the superuser "Athena simulator" tab. Same conventions as
// ../AccessSimulator/actions.js: the `portal/` prefix is spelled out, and every
// call carries the selected org (`org_uuid`: query on GET / DELETE and on the
// body-less actions, body field otherwise).

const BASE = 'portal/dev/athena-simulator';

export const GET_ATHENA_SIM_CONFIG = 'GET_ATHENA_SIM_CONFIG';
export const GET_ATHENA_SIM_CONFIG_RESULT = `${GET_ATHENA_SIM_CONFIG}/result`;
export const LIST_ATHENA_SIM_PROVIDERS = 'LIST_ATHENA_SIM_PROVIDERS';
export const LIST_ATHENA_SIM_PROVIDERS_RESULT = `${LIST_ATHENA_SIM_PROVIDERS}/result`;
export const LIST_ATHENA_SIM_PATIENTS = 'LIST_ATHENA_SIM_PATIENTS';
export const LIST_ATHENA_SIM_PATIENTS_RESULT = `${LIST_ATHENA_SIM_PATIENTS}/result`;
export const GET_ATHENA_SIM_COMM_LOG = 'GET_ATHENA_SIM_COMM_LOG';
export const GET_ATHENA_SIM_COMM_LOG_RESULT = `${GET_ATHENA_SIM_COMM_LOG}/result`;
export const ATHENA_SIM_WRITE = 'ATHENA_SIM_WRITE';
export const ATHENA_SIM_WRITE_RESULT = `${ATHENA_SIM_WRITE}/result`;

const withOrg = (orgUUID, params) => (orgUUID ? { ...params, org_uuid: orgUUID } : params);

const get = (path, type, orgUUID, params) => ({
  [API_CALL]: { method: 'GET', endpoint: `${BASE}/${path}`, params: withOrg(orgUUID, params) },
  type,
});

// Every mutation shares one action type: the tab only needs to know whether it
// succeeded, and reloads afterwards.
const write = (method, path, orgUUID, body) => ({
  [API_CALL]: body === undefined
    ? { method, endpoint: `${BASE}/${path}`, params: withOrg(orgUUID) }
    : { method, endpoint: `${BASE}/${path}`, data: withOrg(orgUUID, body) },
  type: ATHENA_SIM_WRITE,
});

export const actions = {
  getMyOrgs: orgFilterActions.getMyOrgs,
  getConfig: orgUUID => get('config', GET_ATHENA_SIM_CONFIG, orgUUID),
  listProviders: orgUUID => get('providers', LIST_ATHENA_SIM_PROVIDERS, orgUUID),
  listPatients: orgUUID => get('patients', LIST_ATHENA_SIM_PATIENTS, orgUUID),
  getCommLog: orgUUID => get('communication', GET_ATHENA_SIM_COMM_LOG, orgUUID, { limit: 500 }),
  pointOrg: orgUUID => write('PUT', 'point-org', orgUUID, {}),
  unpointOrg: orgUUID => write('PUT', 'unpoint-org', orgUUID),
  setSettings: (settings, orgUUID) => write('PUT', 'settings', orgUUID, settings),
  addSampleData: (practiceId, orgUUID) => write('POST', 'sample-data', orgUUID, { practice_id: practiceId }),
  reset: orgUUID => write('POST', 'reset', orgUUID),
  saveProvider: (id, provider, orgUUID) => (id
    ? write('PUT', `providers/${id}`, orgUUID, provider)
    : write('POST', 'providers', orgUUID, provider)),
  deleteProvider: (id, orgUUID) => write('DELETE', `providers/${id}`, orgUUID),
  savePatient: (id, patient, orgUUID) => (id
    ? write('PUT', `patients/${id}`, orgUUID, patient)
    : write('POST', 'patients', orgUUID, patient)),
  deletePatient: (id, orgUUID) => write('DELETE', `patients/${id}`, orgUUID),
};
